import { Component, OnInit, ChangeDetectorRef, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NbLoginComponent, NbAuthOAuth2JWTToken, NbAuthResult, NbAuthService, NB_AUTH_OPTIONS } from '@nebular/auth';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class NgxLoginComponent extends NbLoginComponent implements OnInit {

  env = environment;
  returnUrl: string;

  constructor(
    service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) options: {},
    cd: ChangeDetectorRef,
    router: Router,
    private route: ActivatedRoute
  ) {
    super(service, options, cd, router);
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/pages';
    
    this.service.getToken().subscribe((token: NbAuthOAuth2JWTToken) => {
       if (token.isValid()) {
         this.router.navigate([this.returnUrl]);
       }
    });
  }

  login(): void {
    this.errors = [];
    this.messages = [];
    this.submitted = true;

    this.service.authenticate(this.strategy, this.user).subscribe((result: NbAuthResult) => {
      this.submitted = false;

      if (result.isSuccess()) {
        this.messages = result.getMessages();
        setTimeout(() => {
          this.router.navigate([this.returnUrl]);
        }, this.redirectDelay);
      } else {
        this.errors = result.getErrors();
      }

      this.cd.detectChanges();
    });
  }

  socialLogin(socialLink) {
    switch (socialLink) {
      case 'google':
        this.service.authenticate('google')
          .subscribe((authResult: NbAuthResult) => {
            if (authResult.isSuccess()) {
              this.router.navigate([this.returnUrl]);
            }
          });
        break;
      case 'facebook':
        this.service.authenticate('facebook')
          .subscribe((authResult: NbAuthResult) => {
            if (authResult.isSuccess()) {
              this.router.navigate([this.returnUrl]);
            }
          });
        break;
      case 'linkedin':
        this.service.authenticate('linkedin')
          .subscribe((authResult: NbAuthResult) => {
            if (authResult.isSuccess()) {
              this.router.navigate([this.returnUrl]);
            }
          });
        break;
    }
  }
}
